import React from "react";

const Calendar2 = () => {
  return (
    <div className="flex self-stretch flex-1 justify-start items-start flex-col relative">
      <div className="flex self-stretch flex-1 justify-start items-start flex-row pt-2 relative">
        <div className="flex justify-start items-start flex-col">
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB]  w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "30px",
                top: "-8px",
                height: "18px",
              }}
            >
              8 AM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r  w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "30px",
                top: "-8px",
                height: "18px",
              }}
            >
              9 AM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "36px",
                top: "-8px",
                height: "18px",
              }}
            >
              10 AM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "34px",
                top: "-8px",
                height: "18px",
              }}
            >
              11 AM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "35px",
                top: "-8px",
                height: "18px",
              }}
            >
              12 PM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "28px",
                top: "-8px",
                height: "18px",
              }}
            >
              1 PM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "29px",
                top: "-8px",
                height: "18px",
              }}
            >
              2 PM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "30px",
                top: "-8px",
                height: "18px",
              }}
            >
              3 PM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "30px",
                top: "-8px",
                height: "18px",
              }}
            >
              4 PM
            </span>
          </div>
          <div
            className="flex justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border-r w-[72px] h-[96px] relative"
            style={{ width: "72px" }}
          >
            <span
              className="text-[#717680] text-xs font-['Inter'] text-right font-medium absolute"
              style={{
                right: "8px",
                width: "30px",
                top: "-8px",
                height: "18px",
              }}
            >
              5 PM
            </span>
          </div>
        </div>
        <div className="flex flex-1 justify-start items-start flex-col">
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[48px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#414651] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[96px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#EFF8FF] border-solid border-[#B2DDFF] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#175CD3] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#1570EF] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
        </div>
        <div className="flex flex-1 justify-start items-start flex-col">
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[96px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#FDF2FA] border-solid border-[#FCCEEE] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#C11574] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#DD2590] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[144px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#F5FFF8] border-solid border-[#D7FEE7] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#009C97] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#009C97] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
        </div>
        <div className="flex flex-1 justify-start items-start flex-col">
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[144px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#EFF8FF] border-solid border-[#B2DDFF] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#175CD3] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#1570EF] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[96px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#EEF4FF] border-solid border-[#C7D7FE] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#3538CD] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#444CE7] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[96px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#414651] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#535862] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-center items-start flex-col p-1.5 absolute w-[149px] h-[192px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#FEF6EE] border-solid border-[#F9DBAF] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#B93815] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#E04F16] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
        </div>
        <div className="flex flex-1 justify-start items-start flex-col">
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[96px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#EDFCF2] border-solid border-[#AAF0C4] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#087443] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#099250] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
        </div>
        <div className="flex flex-1 justify-start items-start flex-col">
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[48px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#414651] text-xs font-['Inter'] font-semibold">
                      Friday standup
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[96px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#F4F3FF] border-solid border-[#D9D6FE] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#5925DC] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#6938EF] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-center items-start flex-col p-1.5 absolute w-[149px] h-[192px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#EEF4FF] border-solid border-[#C7D7FE] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#3538CD] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#444CE7] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
        </div>
        <div className="flex flex-1 justify-start items-start flex-col">
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[48px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#414651] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
        </div>
        <div className="flex flex-1 justify-start items-start flex-col">
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>

          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] relative">
            <div
              className="flex justify-start items-start flex-col p-1.5 absolute w-[149px] h-[96px]"
              style={{
                top: "0px",
                bottom: "0px",
                height: "calc(100% - 0px - 0px)",
                left: "0px",
                right: "0.14px",
                width: "calc(100% - 0px - 0.14px)",
              }}
            >
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-1 py-1.5 px-2 bg-[#FEFBE8] border-solid border-[#FEEE95] border rounded-md">
                <div className="flex flex-1 justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-start flex-row gap-0.5">
                    <p className="flex-1 text-[#A15C07] text-xs font-['Inter'] font-semibold">
                      Monday standup
                    </p>
                  </div>
                  <p className="self-stretch text-[#CA8504] text-xs font-['Inter']">
                    9:00 AM
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF]">
            <div className="flex self-stretch justify-start items-start flex-col p-2 border-solid border-[#E9EAEB] border-b  h-[48px]"></div>
          </div>
        </div>
        <div
          className="absolute"
          style={{
            right: "0px",
            width: "16px",
            top: "40px",
            bottom: "0px",
            height: "calc(100% - 40px - 0px)",
          }}
        >
          <svg
            width="16"
            height="776"
            viewBox="0 0 16 776"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.15"
              d="M8 3.5C5.51472 3.5 3.5 5.51473 3.5 8.00001V412C3.5 414.485 5.51472 416.5 8 416.5C10.4853 416.5 12.5 414.485 12.5 412V8C12.5 5.51472 10.4853 3.5 8 3.5Z"
              fill="black"
              stroke="white"
            />
          </svg>
        </div>
        <div
          className="flex justify-start items-center flex-row gap-1 absolute w-[1116px]"
          style={{
            top: "604px",
            height: "18px",
            left: "0px",
            right: "0px",
            width: "calc(100% - 0px - 0px)",
          }}
        >
          <p className="text-[#009C97] text-xs font-['Inter'] text-right font-medium">
            2:20 PM
          </p>
          <svg
            width="1048"
            height="8"
            viewBox="0 0 1048 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="4" cy="4" r="4" fill="#009C97" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1048 4C1048 4.27614 1047.78 4.5 1047.5 4.5H6.5C6.22386 4.5 6 4.27614 6 4C6 3.72386 6.22383 3.5 6.49997 3.5H1047.5C1047.78 3.5 1048 3.72386 1048 4Z"
              fill="#009C97"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Calendar2;
const Modal = () => {
  return (
    <div>
      <div
        className="flex justify-start items-center flex-col bg-[#FFFFFF] rounded-xl shadow-xl w-[508px] relative"
        style={{ width: "508px" }}
      >
        <div
          className="absolute w-[336px] h-[336px] relative"
          style={{ left: "254px", width: "336px", top: "0px", height: "336px" }}
        >
          <div
            className="flex justify-center items-center flex-row absolute"
            style={{
              top: "0px",
              height: "336px",
              left: "calc(100% - 336px + 0px)",
              width: "336px",
            }}
          >
            <div
              className="flex justify-center items-center flex-row"
              style={{
                background:
                  "radial-gradient(50% 50% at 50% 50%, #000000 0,rgba(0,0,0,0) 100.00%)",
              }}
            ></div>
          </div>
          <svg
            width="254"
            height="337"
            viewBox="0 0 254 337"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="168" cy="168.5" r="47.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168.5" r="47.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168.5" r="71.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168.5" r="95.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168.5" r="119.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168.5" r="143.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168.5" r="167.5" stroke="#E9EAEB" />
          </svg>
        </div>
        <div className="flex self-stretch justify-start items-center flex-col border-solid border-[rgba(0,0,0,0.1)] border-b relative">
          <div className="flex self-stretch justify-start items-start flex-col gap-4 pt-[24px] px-[24px]">
            <div
              className="flex justify-center items-center flex-row p-3 bg-[#F5F5F5] rounded-full w-[48px] h-[48px]"
              style={{ width: "48px" }}
            >
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 10.5H3M16 2.5V6.5M8 2.5V6.5M7.8 22.5H16.2C17.8802 22.5 18.7202 22.5 19.362 22.173C19.9265 21.8854 20.3854 21.4265 20.673 20.862C21 20.2202 21 19.3802 21 17.7V9.3C21 7.61984 21 6.77976 20.673 6.13803C20.3854 5.57354 19.9265 5.1146 19.362 4.82698C18.7202 4.5 17.8802 4.5 16.2 4.5H7.8C6.11984 4.5 5.27976 4.5 4.63803 4.82698C4.07354 5.1146 3.6146 5.57354 3.32698 6.13803C3 6.77976 3 7.61984 3 9.3V17.7C3 19.3802 3 20.2202 3.32698 20.862C3.6146 21.4265 4.07354 21.8854 4.63803 22.173C5.27976 22.5 6.11984 22.5 7.8 22.5Z"
                  stroke="#717680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col gap-1">
              <p className="self-stretch text-[#181D27] text-lg font-['Inter'] font-semibold">
                Schedule Interview
              </p>
              <p className="self-stretch text-[#535862] text-sm font-['Inter']">
                Please enter the details below to add invitees
              </p>
            </div>
          </div>
          <div
            className="flex justify-center items-center flex-row p-2 rounded-lg absolute w-[44px] h-[44px]"
            style={{
              right: "232px",
              width: "44px",
              top: "140px",
              height: "44px",
            }}
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6.5L6 18.5M6 6.5L18 18.5"
                stroke="#A4A7AE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col h-[20px]"></div>
        </div>
        <div className="flex self-stretch justify-start items-start flex-col gap-5 pt-[24px] px-[24px]">
          <div className="flex self-stretch justify-start items-center flex-row gap-3">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="flex flex-1 justify-start items-start flex-col gap-[3px]">
              <div className="flex self-stretch justify-start items-center flex-row gap-4">
                <span className="text-[#181D27] font-['Inter'] leading-6">
                  Monday | March 20, 2025
                </span>
                <div className="flex justify-start items-center flex-row gap-1.5">
                  <span className="text-[#181D27] font-['Inter'] leading-6">
                    10:20 AM
                  </span>
                  <span className="text-[#181D27] font-['Inter'] leading-6">
                    -
                  </span>
                  <span className="text-[#181D27] font-['Inter'] leading-6">
                    11:10 AM
                  </span>
                </div>
              </div>
              <p className="self-stretch text-[#535862] text-sm font-['Inter'] leading-5">
                Eastern Standard Time Zone
              </p>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-row gap-2">
            <div
              className="shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] w-[44px] h-[44px]"
              style={{ width: "44px" }}
            >
              <svg
                width="40"
                height="39"
                viewBox="0 0 40 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.75 13.9389C0.75 9.14733 0.75 6.75155 1.6825 4.92141C2.50275 3.31158 3.81158 2.00275 5.42141 1.1825C7.25155 0.25 9.64733 0.25 14.4389 0.25H25.5611C30.3527 0.25 32.7485 0.25 34.5786 1.1825C36.1884 2.00275 37.4972 3.31158 38.3175 4.92141C39.25 6.75155 39.25 9.14733 39.25 13.9389V25.0611C39.25 29.8527 39.25 32.2485 38.3175 34.0786C37.4972 35.6884 36.1884 36.9972 34.5786 37.8175C32.7485 38.75 30.3527 38.75 25.5611 38.75H14.4389C9.64733 38.75 7.25155 38.75 5.42141 37.8175C3.81158 36.9972 2.50275 35.6884 1.6825 34.0786C0.75 32.2485 0.75 29.8527 0.75 25.0611V13.9389Z"
                  fill="white"
                />
                <path
                  d="M1.25 13.9389C1.25 11.5349 1.25039 9.76191 1.3649 8.36033C1.47894 6.9646 1.70365 5.98124 2.128 5.14841C2.90032 3.63266 4.13266 2.40032 5.64841 1.628C6.48124 1.20365 7.4646 0.978938 8.86033 0.864902C10.2619 0.750389 12.0349 0.75 14.4389 0.75H25.5611C27.9651 0.75 29.7381 0.750389 31.1397 0.864902C32.5354 0.978938 33.5188 1.20365 34.3516 1.628C35.8673 2.40032 37.0997 3.63266 37.872 5.14841C38.2963 5.98124 38.5211 6.9646 38.6351 8.36033C38.7496 9.76191 38.75 11.5349 38.75 13.9389V25.0611C38.75 27.4651 38.7496 29.2381 38.6351 30.6397C38.5211 32.0354 38.2963 33.0188 37.872 33.8516C37.0997 35.3673 35.8673 36.5997 34.3516 37.372C33.5188 37.7963 32.5354 38.0211 31.1397 38.1351C29.7381 38.2496 27.9651 38.25 25.5611 38.25H14.4389C12.0349 38.25 10.2619 38.2496 8.86033 38.1351C7.4646 38.0211 6.48124 37.7963 5.64841 37.372C4.13266 36.5997 2.90032 35.3673 2.128 33.8516C1.70365 33.0188 1.47894 32.0354 1.3649 30.6397C1.25039 29.2381 1.25 27.4651 1.25 25.0611V13.9389Z"
                  stroke="black"
                  strokeOpacity="0.1"
                />
              </svg>
              <svg
                width="32"
                height="25"
                viewBox="0 0 32 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.875 22.8945C0.875 23.9885 1.76872 24.8745 2.86986 24.8745H2.89854C1.78053 24.8745 0.875 23.9885 0.875 22.8945Z"
                  fill="#FBBC05"
                />
                <path
                  d="M18.0178 7.54996V12.7194L24.9872 7.09787V2.10499C24.9872 1.01105 24.0935 0.125 22.9923 0.125H7.89338L7.87988 7.54996H18.0178Z"
                  fill="#FBBC05"
                />
                <path
                  d="M18.0177 17.8901H7.86288L7.85107 24.8745H22.9922C24.095 24.8745 24.9871 23.9885 24.9871 22.8946V18.3868L18.0177 12.7207V17.8901Z"
                  fill="#34A853"
                />
                <path
                  d="M7.8933 0.125L0.875 7.54996H7.88149L7.8933 0.125Z"
                  fill="#EA4335"
                />
                <path
                  d="M0.875 17.8906V22.895C0.875 23.989 1.78053 24.875 2.89854 24.875H7.85114L7.86295 17.8906H0.875Z"
                  fill="#1967D2"
                />
                <path
                  d="M7.88149 7.55078H0.875V17.8913H7.86295L7.88149 7.55078Z"
                  fill="#4285F4"
                />
                <path
                  d="M31.115 21.1352V4.14032C30.7221 1.88478 28.2483 4.47032 28.2483 4.47032L24.9888 7.09875V18.3863L29.6547 22.1797C31.3393 22.4008 31.115 21.1352 31.115 21.1352Z"
                  fill="#34A853"
                />
                <path
                  d="M18.0178 12.7195L24.9889 18.3872V7.09961L18.0178 12.7195Z"
                  fill="#188038"
                />
              </svg>
            </div>
            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2">
                    <p className="flex-1 text-[#717680] font-['Inter']">
                      Add meeting link
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Title
                </span>
              </div>
              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2">
                  <p className="flex-1 text-[#717680] font-['Inter']">
                    Meeting title
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5 h-[110px]">
            <div className="flex self-stretch flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Description
                </span>
              </div>
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2">
                  <p className="flex-1 text-[#717680] font-['Inter']">
                    Enter description
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Candidate
                </span>
              </div>
              <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                  <div className="flex flex-1 justify-start items-start flex-row gap-2">
                    <p className="flex-1 text-[#717680] font-['Inter']">
                      Choose candidate
                    </p>
                  </div>
                </div>
                <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 8L10 13L15 8"
                      stroke="#A4A7AE"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-2">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex justify-start items-start flex-row gap-0.5">
                  <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                    Interviewer
                  </span>
                </div>
                <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                    <div className="flex flex-1 justify-start items-start flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">
                        Choose interviewer
                      </p>
                    </div>
                  </div>
                  <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                    <svg
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 8L10 13L15 8"
                        stroke="#A4A7AE"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center flex-row gap-1.5">
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0001 4.66602V16.3327M4.16675 10.4993H15.8334"
                  stroke="#009C97"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[#009C97] text-sm font-['Inter'] font-semibold">
                Add More
              </span>
            </div>
          </div>
        </div>
        <div className="flex self-stretch justify-start items-start flex-col pt-[32px]">
          <div className="flex self-stretch justify-start items-start flex-row gap-3 pb-[24px] px-[24px]">
            <div className="flex flex-1 justify-center items-center flex-row gap-1.5 py-2.5 px-4 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
              <div className="flex justify-center items-center flex-row px-0.5">
                <span className="text-[#414651] font-['Inter'] font-semibold">
                  Cancel
                </span>
              </div>
            </div>
            <div className="flex flex-1 justify-center items-center flex-row gap-1.5 py-2.5 px-4 bg-[#009C97] border-solid border-[undefined] border-2 rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
              <div className="flex justify-center items-center flex-row px-0.5">
                <span className="text-[#FFFFFF] font-['Inter'] font-semibold">
                  Confirm
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const ScheduleInterview = () => {
  return (
    <div>
      <div
        className="flex justify-start items-center flex-col bg-[#FFFFFF] rounded-xl shadow-xl w-[508px] relative"
        style={{ width: "508px" }}
      >
        <div
          className="absolute w-[336px] h-[336px] relative"
          style={{ left: "254px", width: "336px", top: "0px", height: "336px" }}
        >
          <div
            className="flex justify-center items-center flex-row absolute"
            style={{
              top: "0px",
              height: "336px",
              left: "calc(100% - 336px + 0px)",
              width: "336px",
            }}
          >
            <div
              className="flex justify-center items-center flex-row"
              style={{
                background:
                  "radial-gradient(50% 50% at 50% 50%, #000000 0,rgba(0,0,0,0) 100.00%)",
              }}
            ></div>
          </div>
          <svg
            width="254"
            height="336"
            viewBox="0 0 254 336"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="168" cy="168" r="47.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="47.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="71.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="95.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="119.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="143.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="167.5" stroke="#E9EAEB" />
          </svg>
        </div>
        <div className="flex self-stretch justify-start items-center flex-col border-solid border-[rgba(0,0,0,0.1)] border-b relative">
          <div className="flex self-stretch justify-start items-start flex-col gap-4 pt-[24px] px-[24px]">
            <div
              className="flex justify-center items-center flex-row p-3 bg-[#F5F5F5] rounded-full w-[48px] h-[48px]"
              style={{ width: "48px" }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
                  stroke="#717680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col gap-1">
              <p className="self-stretch text-[#181D27] text-lg font-['Inter'] font-semibold">
                Schedule Interview
              </p>
              <p className="self-stretch text-[#535862] text-sm font-['Inter']">
                Please enter the details below to add invitees
              </p>
            </div>
          </div>
          <div
            className="flex justify-center items-center flex-row p-2 rounded-lg absolute w-[44px] h-[44px]"
            style={{
              right: "232px",
              width: "44px",
              top: "92px",
              height: "44px",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#A4A7AE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col h-[20px]"></div>
        </div>
        <div className="flex self-stretch justify-start items-start flex-col gap-5 pt-[24px] px-[24px]">
          <div className="flex self-stretch justify-start items-start flex-row gap-2">
            <div
              className="shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] w-[44px] h-[44px]"
              style={{ width: "44px" }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.75 14.4389C0.75 9.64733 0.75 7.25155 1.6825 5.42141C2.50275 3.81158 3.81158 2.50275 5.42141 1.6825C7.25155 0.75 9.64733 0.75 14.4389 0.75H25.5611C30.3527 0.75 32.7485 0.75 34.5786 1.6825C36.1884 2.50275 37.4972 3.81158 38.3175 5.42141C39.25 7.25155 39.25 9.64733 39.25 14.4389V25.5611C39.25 30.3527 39.25 32.7485 38.3175 34.5786C37.4972 36.1884 36.1884 37.4972 34.5786 38.3175C32.7485 39.25 30.3527 39.25 25.5611 39.25H14.4389C9.64733 39.25 7.25155 39.25 5.42141 38.3175C3.81158 37.4972 2.50275 36.1884 1.6825 34.5786C0.75 32.7485 0.75 30.3527 0.75 25.5611V14.4389Z"
                  fill="white"
                />
                <path
                  d="M1.25 14.4389C1.25 12.0349 1.25039 10.2619 1.3649 8.86033C1.47894 7.4646 1.70365 6.48124 2.128 5.64841C2.90032 4.13266 4.13266 2.90032 5.64841 2.128C6.48124 1.70365 7.4646 1.47894 8.86033 1.3649C10.2619 1.25039 12.0349 1.25 14.4389 1.25H25.5611C27.9651 1.25 29.7381 1.25039 31.1397 1.3649C32.5354 1.47894 33.5188 1.70365 34.3516 2.128C35.8673 2.90032 37.0997 4.13266 37.872 5.64841C38.2963 6.48124 38.5211 7.4646 38.6351 8.86033C38.7496 10.2619 38.75 12.0349 38.75 14.4389V25.5611C38.75 27.9651 38.7496 29.7381 38.6351 31.1397C38.5211 32.5354 38.2963 33.5188 37.872 34.3516C37.0997 35.8673 35.8673 37.0997 34.3516 37.872C33.5188 38.2963 32.5354 38.5211 31.1397 38.6351C29.7381 38.7496 27.9651 38.75 25.5611 38.75H14.4389C12.0349 38.75 10.2619 38.7496 8.86033 38.6351C7.4646 38.5211 6.48124 38.2963 5.64841 37.872C4.13266 37.0997 2.90032 35.8673 2.128 34.3516C1.70365 33.5188 1.47894 32.5354 1.3649 31.1397C1.25039 29.7381 1.25 27.9651 1.25 25.5611V14.4389Z"
                  stroke="black"
                  strokeOpacity="0.1"
                />
              </svg>
              <svg
                width="32"
                height="26"
                viewBox="0 0 32 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.875 23.3945C0.875 24.4885 1.76872 25.3745 2.86986 25.3745H2.89854C1.78053 25.3745 0.875 24.4885 0.875 23.3945Z"
                  fill="#FBBC05"
                />
                <path
                  d="M18.0178 8.04996V13.2194L24.9872 7.59787V2.60499C24.9872 1.51105 24.0935 0.625 22.9923 0.625H7.89338L7.87988 8.04996H18.0178Z"
                  fill="#FBBC05"
                />
                <path
                  d="M18.0177 18.3901H7.86288L7.85107 25.3745H22.9922C24.095 25.3745 24.9871 24.4885 24.9871 23.3946V18.8868L18.0177 13.2207V18.3901Z"
                  fill="#34A853"
                />
                <path
                  d="M7.8933 0.625L0.875 8.04996H7.88149L7.8933 0.625Z"
                  fill="#EA4335"
                />
                <path
                  d="M0.875 18.3906V23.395C0.875 24.489 1.78053 25.375 2.89854 25.375H7.85114L7.86295 18.3906H0.875Z"
                  fill="#1967D2"
                />
                <path
                  d="M7.88149 8.05078H0.875V18.3913H7.86295L7.88149 8.05078Z"
                  fill="#4285F4"
                />
                <path
                  d="M31.115 21.6352V4.64032C30.7221 2.38478 28.2483 4.97032 28.2483 4.97032L24.9888 7.59875V18.8863L29.6547 22.6797C31.3393 22.9008 31.115 21.6352 31.115 21.6352Z"
                  fill="#34A853"
                />
                <path
                  d="M18.0176 13.2195L24.9887 18.8872V7.59961L18.0176 13.2195Z"
                  fill="#188038"
                />
              </svg>
            </div>
            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2">
                    <p className="flex-1 text-[#717680] font-['Inter']">
                      Add meeting link
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-end flex-row gap-3">
            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex justify-start items-start flex-row gap-0.5">
                  <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                    Date & Time
                  </span>
                </div>
                <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                    <div className="flex flex-1 justify-start items-start flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">
                        Choose date
                      </p>
                    </div>
                  </div>
                  <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.5 8.33268H2.5M13.3333 1.66602V4.99935M6.66667 1.66602V4.99935M6.5 18.3327H13.5C14.9001 18.3327 15.6002 18.3327 16.135 18.0602C16.6054 17.8205 16.9878 17.4381 17.2275 16.9677C17.5 16.4329 17.5 15.7328 17.5 14.3327V7.33268C17.5 5.93255 17.5 5.23249 17.2275 4.69771C16.9878 4.2273 16.6054 3.84485 16.135 3.60517C15.6002 3.33268 14.9001 3.33268 13.5 3.33268H6.5C5.09987 3.33268 4.3998 3.33268 3.86502 3.60517C3.39462 3.84485 3.01217 4.2273 2.77248 4.69771C2.5 5.23249 2.5 5.93255 2.5 7.33268V14.3327C2.5 15.7328 2.5 16.4329 2.77248 16.9677C3.01217 17.4381 3.39462 17.8205 3.86502 18.0602C4.3998 18.3327 5.09987 18.3327 6.5 18.3327Z"
                        stroke="#A4A7AE"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-1 justify-start items-start flex-row gap-2">
              <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                    <div className="flex flex-1 justify-start items-center flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">
                        From
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                    <div className="flex flex-1 justify-start items-center flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">To</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Title
                </span>
              </div>
              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2">
                  <p className="flex-1 text-[#717680] font-['Inter']">
                    Meeting title
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5 h-[110px]">
            <div className="flex self-stretch flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Description
                </span>
              </div>
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2">
                  <p className="flex-1 text-[#717680] font-['Inter']">
                    Enter description
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Candidate
                </span>
              </div>
              <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                  <div className="flex flex-1 justify-start items-start flex-row gap-2">
                    <p className="flex-1 text-[#717680] font-['Inter']">
                      Choose candidate
                    </p>
                  </div>
                </div>
                <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 7.5L10 12.5L15 7.5"
                      stroke="#A4A7AE"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-2">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex justify-start items-start flex-row gap-0.5">
                  <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                    Interviewer
                  </span>
                </div>
                <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                    <div className="flex flex-1 justify-start items-start flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">
                        Choose interviewer
                      </p>
                    </div>
                  </div>
                  <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="#A4A7AE"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center flex-row gap-1.5">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.99984 4.16602V15.8327M4.1665 9.99935H15.8332"
                  stroke="#009C97"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[#009C97] text-sm font-['Inter'] font-semibold">
                Add More
              </span>
            </div>
          </div>
        </div>
        <div className="flex self-stretch justify-start items-start flex-col pt-[32px]">
          <div className="flex self-stretch justify-start items-start flex-row gap-3 pb-[24px] px-[24px]">
            <div className="flex flex-1 justify-center items-center flex-row gap-1.5 py-2.5 px-4 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
              <div className="flex justify-center items-center flex-row px-0.5">
                <span className="text-[#414651] font-['Inter'] font-semibold">
                  Cancel
                </span>
              </div>
            </div>
            <div className="flex flex-1 justify-center items-center flex-row gap-1.5 py-2.5 px-4 bg-[#009C97] border-solid border-[undefined] border-2 rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
              <div className="flex justify-center items-center flex-row px-0.5">
                <span className="text-[#FFFFFF] font-['Inter'] font-semibold">
                  Confirm
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const ScheduleInterviewModal2 = () => {
  return (
    <div>
      <div
        className="flex justify-start items-center flex-col bg-[#FFFFFF] rounded-xl shadow-xl w-[508px] relative"
        style={{ width: "508px" }}
      >
        <div
          className="absolute w-[336px] h-[336px] relative"
          style={{ left: "254px", width: "336px", top: "0px", height: "336px" }}
        >
          <div
            className="flex justify-center items-center flex-row absolute"
            style={{
              top: "0px",
              height: "336px",
              left: "calc(100% - 336px + 0px)",
              width: "336px",
            }}
          >
            <div
              className="flex justify-center items-center flex-row"
              style={{
                background:
                  "radial-gradient(50% 50% at 50% 50%, #000000 0,rgba(0,0,0,0) 100.00%)",
              }}
            ></div>
          </div>
          <svg
            width="254"
            height="336"
            viewBox="0 0 254 336"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="168" cy="168" r="47.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="47.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="71.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="95.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="119.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="143.5" stroke="#E9EAEB" />
            <circle cx="168" cy="168" r="167.5" stroke="#E9EAEB" />
          </svg>
        </div>
        <div className="flex self-stretch justify-start items-center flex-col border-solid border-[rgba(0,0,0,0.1)] border-b relative">
          <div className="flex self-stretch justify-start items-start flex-col gap-4 pt-[24px] px-[24px]">
            <div
              className="flex justify-center items-center flex-row p-3 bg-[#F5F5F5] rounded-full w-[48px] h-[48px]"
              style={{ width: "48px" }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
                  stroke="#717680"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col gap-1">
              <p className="self-stretch text-[#181D27] text-lg font-['Inter'] font-semibold">
                Schedule Interview
              </p>
              <p className="self-stretch text-[#535862] text-sm font-['Inter']">
                Please enter the details below to add invitees
              </p>
            </div>
          </div>
          <div
            className="flex justify-center items-center flex-row p-2 rounded-lg absolute w-[44px] h-[44px]"
            style={{
              right: "232px",
              width: "44px",
              top: "140px",
              height: "44px",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#A4A7AE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col h-[20px]"></div>
        </div>
        <div className="flex self-stretch justify-start items-start flex-col gap-5 pt-[24px] px-[24px]">
          <div className="flex self-stretch justify-start items-end flex-row gap-3">
            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex justify-start items-start flex-row gap-0.5">
                  <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                    Date & Time
                  </span>
                </div>
                <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                    <div className="flex flex-1 justify-start items-start flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">
                        Choose date
                      </p>
                    </div>
                  </div>
                  <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.5 8.33268H2.5M13.3333 1.66602V4.99935M6.66667 1.66602V4.99935M6.5 18.3327H13.5C14.9001 18.3327 15.6002 18.3327 16.135 18.0602C16.6054 17.8205 16.9878 17.4381 17.2275 16.9677C17.5 16.4329 17.5 15.7328 17.5 14.3327V7.33268C17.5 5.93255 17.5 5.23249 17.2275 4.69771C16.9878 4.2273 16.6054 3.84485 16.135 3.60517C15.6002 3.33268 14.9001 3.33268 13.5 3.33268H6.5C5.09987 3.33268 4.3998 3.33268 3.86502 3.60517C3.39462 3.84485 3.01217 4.2273 2.77248 4.69771C2.5 5.23249 2.5 5.93255 2.5 7.33268V14.3327C2.5 15.7328 2.5 16.4329 2.77248 16.9677C3.01217 17.4381 3.39462 17.8205 3.86502 18.0602C4.3998 18.3327 5.09987 18.3327 6.5 18.3327Z"
                        stroke="#A4A7AE"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-1 justify-start items-start flex-row gap-2">
              <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                    <div className="flex flex-1 justify-start items-center flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">
                        From
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                    <div className="flex flex-1 justify-start items-center flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">To</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-row gap-2">
            <div
              className="flex justify-center items-center flex-row rounded-full w-[48px] h-[48px]"
              style={{
                background:
                  "url(https://placehold.co/48x48),linear-gradient(0deg, #E0E0E0 0%, #E0E0E0 100%)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                objectFit: "cover",
                width: "48px",
              }}
              src="https://placehold.co/48x48"
            >
              <div className="flex justify-center items-center flex-row border-solid border-[rgba(0,0,0,0.08)] border-[0.75px] rounded-full"></div>
            </div>
            <div className="flex justify-start items-start flex-col">
              <span className="text-[#181D27] font-['Inter'] font-medium leading-6">
                Sienna Hewitt
              </span>
              <span className="text-[#535862] font-['Inter'] leading-6">
                hi@siennahewitt.com
              </span>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-row gap-2">
            <div
              className="shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] w-[44px] h-[44px]"
              style={{ width: "44px" }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.75 14.4389C0.75 9.64733 0.75 7.25155 1.6825 5.42141C2.50275 3.81158 3.81158 2.50275 5.42141 1.6825C7.25155 0.75 9.64733 0.75 14.4389 0.75H25.5611C30.3527 0.75 32.7485 0.75 34.5786 1.6825C36.1884 2.50275 37.4972 3.81158 38.3175 5.42141C39.25 7.25155 39.25 9.64733 39.25 14.4389V25.5611C39.25 30.3527 39.25 32.7485 38.3175 34.5786C37.4972 36.1884 36.1884 37.4972 34.5786 38.3175C32.7485 39.25 30.3527 39.25 25.5611 39.25H14.4389C9.64733 39.25 7.25155 39.25 5.42141 38.3175C3.81158 37.4972 2.50275 36.1884 1.6825 34.5786C0.75 32.7485 0.75 30.3527 0.75 25.5611V14.4389Z"
                  fill="white"
                />
                <path
                  d="M1.25 14.4389C1.25 12.0349 1.25039 10.2619 1.3649 8.86033C1.47894 7.4646 1.70365 6.48124 2.128 5.64841C2.90032 4.13266 4.13266 2.90032 5.64841 2.128C6.48124 1.70365 7.4646 1.47894 8.86033 1.3649C10.2619 1.25039 12.0349 1.25 14.4389 1.25H25.5611C27.9651 1.25 29.7381 1.25039 31.1397 1.3649C32.5354 1.47894 33.5188 1.70365 34.3516 2.128C35.8673 2.90032 37.0997 4.13266 37.872 5.64841C38.2963 6.48124 38.5211 7.4646 38.6351 8.86033C38.7496 10.2619 38.75 12.0349 38.75 14.4389V25.5611C38.75 27.9651 38.7496 29.7381 38.6351 31.1397C38.5211 32.5354 38.2963 33.5188 37.872 34.3516C37.0997 35.8673 35.8673 37.0997 34.3516 37.872C33.5188 38.2963 32.5354 38.5211 31.1397 38.6351C29.7381 38.7496 27.9651 38.75 25.5611 38.75H14.4389C12.0349 38.75 10.2619 38.7496 8.86033 38.6351C7.4646 38.5211 6.48124 38.2963 5.64841 37.872C4.13266 37.0997 2.90032 35.8673 2.128 34.3516C1.70365 33.5188 1.47894 32.5354 1.3649 31.1397C1.25039 29.7381 1.25 27.9651 1.25 25.5611V14.4389Z"
                  stroke="black"
                  strokeOpacity="0.1"
                />
              </svg>
              <svg
                width="32"
                height="26"
                viewBox="0 0 32 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.875 23.3945C0.875 24.4885 1.76872 25.3745 2.86986 25.3745H2.89854C1.78053 25.3745 0.875 24.4885 0.875 23.3945Z"
                  fill="#FBBC05"
                />
                <path
                  d="M18.0178 8.04996V13.2194L24.9872 7.59787V2.60499C24.9872 1.51105 24.0935 0.625 22.9923 0.625H7.89338L7.87988 8.04996H18.0178Z"
                  fill="#FBBC05"
                />
                <path
                  d="M18.0177 18.3901H7.86288L7.85107 25.3745H22.9922C24.095 25.3745 24.9871 24.4885 24.9871 23.3946V18.8868L18.0177 13.2207V18.3901Z"
                  fill="#34A853"
                />
                <path
                  d="M7.8933 0.625L0.875 8.04996H7.88149L7.8933 0.625Z"
                  fill="#EA4335"
                />
                <path
                  d="M0.875 18.3906V23.395C0.875 24.489 1.78053 25.375 2.89854 25.375H7.85114L7.86295 18.3906H0.875Z"
                  fill="#1967D2"
                />
                <path
                  d="M7.88149 8.05078H0.875V18.3913H7.86295L7.88149 8.05078Z"
                  fill="#4285F4"
                />
                <path
                  d="M31.115 21.6352V4.64032C30.7221 2.38478 28.2483 4.97032 28.2483 4.97032L24.9888 7.59875V18.8863L29.6547 22.6797C31.3393 22.9008 31.115 21.6352 31.115 21.6352Z"
                  fill="#34A853"
                />
                <path
                  d="M18.0176 13.2195L24.9887 18.8872V7.59961L18.0176 13.2195Z"
                  fill="#188038"
                />
              </svg>
            </div>
            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2">
                    <p className="flex-1 text-[#717680] font-['Inter']">
                      Add meeting link
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Title
                </span>
              </div>
              <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2">
                  <p className="flex-1 text-[#717680] font-['Inter']">
                    Meeting title
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-1.5 h-[110px]">
            <div className="flex self-stretch flex-1 justify-start items-start flex-col gap-1.5">
              <div className="flex justify-start items-start flex-row gap-0.5">
                <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                  Description
                </span>
              </div>
              <div className="flex self-stretch flex-1 justify-start items-start flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex flex-1 justify-start items-center flex-row gap-2">
                  <p className="flex-1 text-[#717680] font-['Inter']">
                    Enter description
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex self-stretch justify-start items-start flex-col gap-2">
            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                <div className="flex justify-start items-start flex-row gap-0.5">
                  <span className="text-[#414651] text-sm font-['Inter'] font-medium">
                    Interviewer
                  </span>
                </div>
                <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                    <div className="flex flex-1 justify-start items-start flex-row gap-2">
                      <p className="flex-1 text-[#717680] font-['Inter']">
                        Choose interviewer
                      </p>
                    </div>
                  </div>
                  <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="#A4A7AE"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center flex-row gap-1.5">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.99984 4.16602V15.8327M4.1665 9.99935H15.8332"
                  stroke="#009C97"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-[#009C97] text-sm font-['Inter'] font-semibold">
                Add More
              </span>
            </div>
          </div>
        </div>
        <div className="flex self-stretch justify-start items-start flex-col pt-[32px]">
          <div className="flex self-stretch justify-start items-start flex-row gap-3 pb-[24px] px-[24px]">
            <div className="flex flex-1 justify-center items-center flex-row gap-1.5 py-2.5 px-4 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
              <div className="flex justify-center items-center flex-row px-0.5">
                <span className="text-[#414651] font-['Inter'] font-semibold">
                  Cancel
                </span>
              </div>
            </div>
            <div className="flex flex-1 justify-center items-center flex-row gap-1.5 py-2.5 px-4 bg-[#009C97] border-solid border-[undefined] border-2 rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
              <div className="flex justify-center items-center flex-row px-0.5">
                <span className="text-[#FFFFFF] font-['Inter'] font-semibold">
                  Confirm
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
